/** TipTap TextAlign stores physical left | center | right. Map logical start/end for toolbar. */

export function editorDirAttr(textDir) {
  return textDir === 'rtl' ? 'rtl' : 'ltr';
}

export function isRtlTextDir(textDir) {
  return textDir === 'rtl';
}

/** @param {'start' | 'center' | 'end'} logicalAlign */
export function textAlignStorageKey(logicalAlign, textDir) {
  if (logicalAlign === 'center') return 'center';
  if (textDir === 'rtl') {
    return logicalAlign === 'start' ? 'right' : 'left';
  }
  return logicalAlign === 'start' ? 'left' : 'right';
}

export function isLogicalTextAlignActive(editor, logicalAlign, textDir) {
  if (!editor) return false;
  return editor.isActive({ textAlign: textAlignStorageKey(logicalAlign, textDir) });
}

export function resolveBookTextDir(book) {
  const raw = book?.language?.text_direction;
  return raw === 'rtl' ? 'rtl' : 'ltr';
}
